import React from 'react';
import Grid from '@mui/material/Grid';

import { InfoField } from '@occc/ui-design-system';
import { Award_Points_Rounding_Strategy, AwardPointsPerFragment } from '@occc/graphql';

type PointsRoundingMap = {
  [key in Award_Points_Rounding_Strategy]: string;
};
const pointsRoundingMap: PointsRoundingMap = {
  [Award_Points_Rounding_Strategy.Down]: 'Down',
  [Award_Points_Rounding_Strategy.HalfUp]: 'Half up',
};
const formatPointsRounding = ({ rounding }: { rounding: Award_Points_Rounding_Strategy }): string =>
  pointsRoundingMap[rounding];

interface IPointsPerAwardProps {
  award: AwardPointsPerFragment;
}

export const PointsPerAward: React.FC<IPointsPerAwardProps> = ({ award }) => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <InfoField label='Granted points' value={award?.points} />
      </Grid>
      <Grid item sm={3}>
        <InfoField label='Point Rounding' value={formatPointsRounding(award)} />
      </Grid>
    </Grid>
  );
};
